module.exports = __webpack_public_path__ + "img/IMG_7704.67f3ad92.jpg";